<template>
  <div class="layui-fluid">
    <div class="layui-row layui-col-space15">
      <!-- <div class="layui-col-md12">
        <div class="layui-card">
          <div class="layui-card-header">基本信息</div>
          <div class="layui-card-body">
            <table class="layui-table">
              <tbody>
                <tr>
                  <th style="text-align: right">
                    <b>纳税人识别号</b>
                  </th>
                  <td>91310113MA1GMA0N9U</td>
                  <th style="text-align: right">
                    <b>纳税人名称</b>
                  </th>
                  <td>上海迪孚人力资源服务有限公司</td>
                </tr>

                <tr>
                  <th style="text-align: right">
                    <b>官方网站</b>
                  </th>
                  <td>www.dfservice.cn</td>
                  <th style="text-align: right">
                    <b>税务机关名称</b>
                  </th>
                  <td>宝山区税务局第十八税务所</td>
                </tr>

                <tr>
                  <th style="text-align: right">
                    <b>企业总人数</b>
                  </th>
                  <td>100</td>
                  <th style="text-align: right">
                    <b>客户数</b>
                  </th>
                  <td>5</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div> -->
      <!-- <div class="layui-col-md12">
        <div class="layui-card">
          <div class="layui-card-header">考勤情况</div>
          <div class="layui-col-sm6 layui-col-md3">
            <div class="layui-card">
              <div class="layui-card-header">
                本月应考勤人数：100
              </div>
            </div>
          </div>
          <div class="layui-col-sm6 layui-col-md3">
            <div class="layui-card">
              <div class="layui-card-header">
                本月已考勤人数：100
              </div>
            </div>
          </div>
          <div class="layui-col-sm6 layui-col-md3">
            <div class="layui-card">
              <div class="layui-card-header">
              </div>
            </div>
          </div>
          <div class="layui-col-sm6 layui-col-md3">
            <div class="layui-card">
              <div class="layui-card-header">
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="layui-col-md12">
        <div class="layui-card">
          <div class="layui-card-header">报销情况</div>
          <div class="layui-col-sm6 layui-col-md3">
            <div class="layui-card">
              <div class="layui-card-header">
                上月报销
                <span
                  class="layui-badge layui-bg-cyan layuiadmin-badge"
                  style="background-color: rgba(30, 144, 255, 1) !important"
                  >月</span
                >
              </div>
              <div class="layui-card-body">
                <p class="layuiadmin-big-font">报销人数：11</p>
                <p class="layuiadmin-big-font">报销金额：￥4,545</p>
              </div>
            </div>
          </div>
          <div class="layui-col-sm6 layui-col-md3">
            <div class="layui-card">
              <div class="layui-card">
                <div class="layui-card-header">
                  本月报销
                  <span
                    class="layui-badge layui-bg-cyan layuiadmin-badge"
                    style="background-color: rgba(30, 144, 255, 1) !important"
                    >月</span
                  >
                </div>
                <div class="layui-card-body">
                  <p class="layuiadmin-big-font">报销人数：11</p>
                  <p class="layuiadmin-big-font">报销金额：￥4,545</p>
                </div>
              </div>
            </div>
          </div>
          <div class="layui-col-sm6 layui-col-md3">
            <div class="layui-card">
              <div class="layui-card-header">
                上年报销
                <span
                  class="layui-badge layui-bg-cyan layuiadmin-badge"
                  style="background-color: red !important"
                  >年</span
                >
              </div>
              <div class="layui-card-body">
                <p class="layuiadmin-big-font">报销人数：11</p>
                <p class="layuiadmin-big-font">报销金额：￥4,545</p>
              </div>
            </div>
          </div>
          <div class="layui-col-sm6 layui-col-md3">
            <div class="layui-card">
              <div class="layui-card-header">
                本年报销
                <span
                  class="layui-badge layui-bg-cyan layuiadmin-badge"
                  style="background-color: red !important"
                  >年</span
                >
              </div>
              <div class="layui-card-body">
                <p class="layuiadmin-big-font">报销人数：11</p>
                <p class="layuiadmin-big-font">报销金额：￥4,545</p>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="layui-col-md12">
        <div class="layui-card">
          <div class="layui-card-header">发票库存</div>
          <div class="layui-col-sm12 layui-col-md6">
            <div class="layui-card">
              <div class="layui-card-header">
                增值税电子发票普票
                <span
                  class="layui-badge layui-bg-cyan layuiadmin-badge"
                  style="background-color: purple !important"
                  >余票</span
                >
              </div>
              <div class="layui-card-body">
                <p class="layuiadmin-big-font">发票量：5,211</p>
              </div>
            </div>
          </div>
          <div class="layui-col-sm12 layui-col-md6">
            <div class="layui-card">
              <div class="layui-card-header">
                增值税电子发票专票
                <span
                  class="layui-badge layui-bg-cyan layuiadmin-badge"
                  style="background-color: purple !important"
                  >余票</span
                >
              </div>
              <div class="layui-card-body">
                <p class="layuiadmin-big-font">发票量：3,000</p>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<style>
@import "../../static/css/xadmin.css";
.delete {
  width: 20px;
  height: 20px;
  border-radius: 60%;
  position: absolute;
  top: -10px;
  right: -10px;
}
</style>
<style scoped>
.dashboard-stats {
  float: left;
  width: 20%;
}

.dashboard-stats-item {
  position: relative;
  overflow: hidden;
  color: #fff;
  cursor: pointer;
  margin-right: 5px;
}

.dashboard-stats-item h2 {
  font-size: 35px;
  font-family: inherit;
  line-height: 1.1;
  font-weight: 500;
}

.dashboard-stats-item h5 {
  font-size: 14px;
  font-family: inherit;
  margin-top: 3px;
  line-height: 1.1;
}

.dashboard-stats-item .stat-icon {
  position: absolute;
  top: 0px;
  right: 10px;
  font-size: 10px;
  opacity: 0.3;
}
</style>
<script>
export default {
  data() {
    return {
      cygn: [],
      zwlj: [],
      cygnObject: {},
      zwljObject: {},
      xszy: true,
      step: 0,
      bzxh: 0,
      isReloadData: false,
      isshow: false,
      isalert: false,
      tips: "",
    };
  },
  created() {},
  methods: {},
};
</script>


// WEBPACK FOOTER //
// src/view/welcome.vue